module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//blue_1.png?v=4f3f1879";